import { render, staticRenderFns } from "./basicSettingTest.vue?vue&type=template&id=562013a4&scoped=true&"
import script from "./basicSettingTest.vue?vue&type=script&lang=js&"
export * from "./basicSettingTest.vue?vue&type=script&lang=js&"
import style0 from "./basicSettingTest.vue?vue&type=style&index=0&id=562013a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562013a4",
  null
  
)

export default component.exports